import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from './Card';

export default styled.table`
  width: 755px;
  padding: 16px;
  display: block;
  text-align: center;

  ${upTo(breakpoint)`
    display: none;
  `}
`;
